<template>
  <div>
    <b-navbar fixed="top" toggleable="lg" type="dark" variant="purple">
      <b-navbar-brand class="mb-0 mt-0" to="calendar">
        <b-media>
          <template v-slot:aside>
            <img
              src="@/assets/img/headLogo.png"
              width="45"
              height="45"
              class="mt-1 d-inline-block align-middle mr-0"
              alt="logo"
            />
          </template>
          <h4 class="mt-1 mb-0">MY MUIC</h4>
          <h6 class="mt-0 text-capitalize">Web Portal</h6>
        </b-media>
      </b-navbar-brand>
      <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
        <template class="" v-slot:button-content>
          <button
            class="mt-0 navbar-toggler navbar-burger"
            type="button"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-bar"></span>
            <span class="navbar-toggler-bar"></span>
            <span class="navbar-toggler-bar"></span>
          </button>
        </template>
        <b-dropdown-item to="/profile"
          ><i class="fa fa-user mr-1" aria-hidden="true"></i
          >Profile</b-dropdown-item
        >
        <b-dropdown-item :href="$keycloak.createLogoutUrl()"
          ><i class="fa fa-key mr-1" aria-hidden="true"></i>Change
          Password</b-dropdown-item
        >
        <b-dropdown-item :href="$keycloak.createLogoutUrl()"
          ><i class="fa fa-sign-out mr-1" aria-hidden="true"></i>Log
          out</b-dropdown-item
        >
      </b-dropdown>
      <b-collapse id="collapse" is-nav>
        <!-- {{ $keycloak.fullName }} -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown class="text-center" text="Lang" right no-caret>
            <template #button-content>
              <div class="d-flex w-100 justify-content-between">
                <b-media class="text-white mb-0">
                  <template #aside>
                    <img
                      v-if="imageView !== ''"
                      :src="imageView"
                      style="width: 40px; height: 40px"
                      class="align-middle img-thumbnail rounded-circle"
                      alt="avatar.png"
                    />
                    <img
                      v-else
                      style="width: 40px; height: 40px"
                      src="@/assets/img/avatar.png"
                      class="align-middle img-thumbnail rounded-circle"
                      alt="avatar.png"
                    />
                  </template>
                  <h4
                    class="text-capitalize profile-font float-center mt-0 mb-1"
                  >
                    {{ $keycloak.fullName }}
                  </h4>
                  <h5
                    class="
                      text-capitalize
                      profile-font
                      text-white
                      float-left
                      mt-0
                      mb-0
                    "
                  >
                    MUIC Account : {{ $keycloak.userName }}
                  </h5>
                </b-media>
                <i class="fa fa-caret-down ml-2 mt-0" aria-hidden="true"></i>
              </div>
            </template>
            <!-- <b-dropdown-item class="font-weight-bold profile-font">MUIC Account : {{ $keycloak.userName }}</b-dropdown-item> -->
            <b-dropdown-item
              @click="
                $refs.fileInput2.$el.querySelector('input[type=file]').click()
              "
            >
              <span class="profile-font"
                ><i class="mt-2 mb-2 fa fa-picture-o" aria-hidden="true"></i
                >Update Avatar</span
              >
            </b-dropdown-item>
            <b-dropdown-item to="/profile">
              <span class="profile-font"
                ><i class="fa fa-user mr-1" aria-hidden="true"></i>Profile</span
              >
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item
              href="https://iforgot.muic.mahidol.ac.th"
              target="_blank"
            >
              <span class="profile-font"
                ><i class="fa fa-key mr-1" aria-hidden="true"></i>Change
                Password</span
              >
            </b-dropdown-item>
            <b-dropdown-item :href="$keycloak.createLogoutUrl()">
              <span class="text-danger profile-font"
                ><i class="fa fa-sign-out mr-1" aria-hidden="true"></i>Log
                out</span
              >
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item class="text-capitalize">&nbsp;</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-form-file
      ref="fileInput2"
      @change="UploadProfile"
      v-model="photoProfile"
      style="display: none"
    />
    <div class="contact-us full-screen bg-main">
      <div class="mb-3 wrapper-full-page section content main">
        <b-row class="mt-4">
          <b-col xl="9" lg="12">
            <!-- New Links -->
            <div class="mb-5">
              <h5 class="mt-1 mb-2 font-weight-bold">
                <i class="fa fa-fire mr-2 text-warning" aria-hidden="true" />New
                Links
              </h5>
              <hr class="mt-2 mb-2" />
              <div class="row">
                  <div class="col-sm-12 col-md-4">
                  <b-button
                    variant="outline-info"
                    target="_blank"
                    href="https://newmy.muic.io/calendar"
                    block
                    class="font-weight-bold"
                    ><h5 class="font-weight-bold mt-0 mb-0"><b-badge
                        variant="success"
                        class="mr-2 align-top text-lowercase"
                        >New interface</b-badge>MY MUIC</h5></b-button
                  >
                  </div>
              </div>
              <div
                v-if="
                  this.$store.state.permit.RulesUser.roles.includes('faculty')
                "
              >
                <p class="mt-3 mb-2 font-weight-bold">For instructor</p>
                <div class="row">
                  <div class="col-sm-12 col-md-4">
                    <b-button
                      variant="outline-info"
                      href="https://instructor.muic.io/overview"
                      target="_blank"
                      block
                      class="mb-2"
                      ><h5 class="font-weight-bold mt-0 mb-0"><b-badge
                        variant="success"
                        class="mr-2 align-top"
                        >New</b-badge
                      >SKY+ instructor site</h5></b-button
                    >
                  </div>
                </div>
                <!-- <b-link
                  href="https://drive.google.com/file/d/1UwAo1dtf30XWEgTjY5zaLAvchh2ByI1n/view?usp=sharing"
                  target="_blank"
                  class="font-weight-bold mt-5 mb-1"
                  >( <i class="fa fa-file-pdf-o" aria-hidden="true" /> Manual )</b-link
                > -->
              </div>
            </div>
            <!-- 1. card-profile -->
            <!--
              <portal-profile
                  class="card-custom"
                  :role="this.$store.state.permit.RulesUser.roles"
                  :MaxScale="MaxScale"
                  :windowWidth="window.width"
              ></portal-profile>
          -->
            <!-- 2. Menu Service -->
            <portal-menu :MaxScale="MaxScale"></portal-menu>
          </b-col>
          <b-col xl="3" lg="12">
            <!-- 3. Announcement & Facebook Fanpage -->
            <portal-announce :MaxScale="MaxScale"></portal-announce>
          </b-col>
        </b-row>
      </div>
      <br /><br />
      <footer class="footer">
        <div class="container-fluid" style="background-color: #565656">
          <!-- 2. Footer -->
          <portal-footer :MaxScale="MaxScale"></portal-footer>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import store from "@/store/index";
import portalProfile from "./portal_profile";
import portalMenu from "./portal_menu";
import portalAnnounce from "./portal_announce.vue";
import portalFooter from "./portal_footer";
export default {
  components: {
    portalProfile,
    portalMenu,
    portalAnnounce,
    portalFooter,
  },
  data() {
    return {
      window: {
        width: 0,
        height: 0,
      },
      MaxScale: "Monitor",
      imageView: "",
      photoProfile: null,
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  mounted() {
    this.readPhotoFile();
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width <= 1366) {
        this.MaxScale = "miniMonitor";
      } else {
        this.MaxScale = "Monitor";
      }
    },
    ImageProfile(val) {
      return val !== null && val !== "null" ? val : `@/assets/img/avatar.png`;
    },
    async readPhotoFile() {
      try {
        const res = await this.$http
          .get(`/portal/profile/get_img/`, { responseType: "blob" })
          .then((res) => {
            if (res.status === 200) {
              let blob = new Blob([res.data]);
              return (this.imageView = this.ImageProfile(
                window.URL.createObjectURL(blob)
              ));
            } else {
              throw { res };
            }
          });
      } catch (error) {
        return (this.imageView = "");
      }
    },
    async UploadProfile(event) {
      const sendPhoto = new FormData();
      sendPhoto.append("pic", event.target.files[0]);
      try {
        const res = await this.$http
          .post(`/portal/profile/update_img/`, sendPhoto, {
            responseType: "blob",
          })
          .then((res) => {
            if (res.status === 200) {
              this.readPhotoFile();
            }
          });
      } catch (error) {}
    },
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Baloo+Tamma+2&family=Varela+Round&display=swap");
@import url("https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.0.0/animate.min.css");
.main {
  padding: 20px;
}
.bg-main {
  background-color: #ffffff;
  margin-top: 70px;
}
.card-custom {
  /* Add shadows to create the "card" effect */
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 20px;
}
.f-500 {
  font-weight: 500;
}
.profile-font {
  font-family: "Baloo Tamma 2", cursive;
}
.nav-font {
  font-family: "Varela Round", sans-serif;
}
.bg-purple {
  background-color: #452b73 !important;
}
</style>